<template>
  <div>
    <el-row  class='post_content'>
        <el-col :span="24" class='content_top'>
            <p class='enroll'>报名步骤</p>
            <div class='menu'>
                <span class='menu_style selected'>1、填写表单</span>
                <span class='arrow'>》</span>
                <span class='menu_style'>2、确定支付</span>
                <span class='arrow'>》</span>
                <span class='menu_style'>3、完成支付</span>
            </div>
        </el-col>
        <el-col :span="24" class='content_desc'>
            <div>
                <p class='normal desc_list' v-for='(list,index) in desc_list' :key='index' v-html="list.text"></p>
            </div>
            <div>
                <p class='normal' v-for='(attlist,index) in attent_list' :key="index" v-html="attlist.attent" @click='courseClick(index)'></p>
            </div>
            <!-- todo  -->
            <!-- <div>
              <p class='normal desc_list'>五、报名流程</p>
              <p class='normal'>登录江苏省音乐家协会官网（www.江苏音协.com）；点击右侧考试报名→“江苏省音乐家协会考级报名”，注册账号后登录报名系统。正确填写相关信息后点击“提交”，进入缴费页面，然后通过支付宝、微信进行网上缴费；缴费成功后，系统将生成准考证，请打印准考证作为考试凭据。</p>
            </div> -->
        </el-col>
         <el-col :span="24" class='button_btn'>
            <button class='btn' @click='sendFill'>我已阅读，立即报名</button>
        </el-col> 
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
      return {
        // todo  
        desc_list:[
          {text:`<span>各位考生、家长和老师，请在报名前认真阅读2020年江苏省音乐家协会寒假考试报名须知。这将为您提供更多方便和帮助。</span>`},
          {text:`<p>本次网络报名只针对2020年1月19日—1月20日在南京高等职业技术学校（黄山路58号）乐理辅导及考试和2020年1月19日—1月20日在江苏艺术剧场（南京市建邺区梦都大街50号江苏省文联二楼）钢琴演奏级的考生。</p>`},
          {text:`<p>报名时间为<span class="f7">2020年1月1日至2020年1月14日</span>，逾期不予报名。</p>`},
          {text:`<p>请正确填写相关信息后点击“提交”，进入缴费页面，然后通过支付宝进行网上缴费；缴费成功后，系统将生成准考证，请打印准考证作为考试凭据。</p>`}, 
          {text:`<span class="f7">注意事项：</span>`} 
        ],
        attent_list:[
          {attent:`1、妥善保管账号及密码，以前注册过的帐号可以继续使用。`},
          {attent:`2、提交报名信息前，<span class='ipmStyle'>请仔细核对考生报考信息（身份证号、级别、辅导课等），付款成功后，将无法更改信息以及退款。</span>`},
          {attent:`3、提交报名表信息后请在30分钟内付款，超过时间需要重新填写报名信息。`},
          {attent:`4、参加乐理补考的考生，请在备注框中填写已通过的准考证号码及具体考试地点。（成绩三年内有效（含考级当年），逾期无效）`},
          {attent:`5、请考生根据实际情况，选择是否参加寒假乐理辅导。`},
          {attent:`6、乐理考试当天，<span class='ipmStyle'>请补考乐理的考生携带 1张2寸证件照</span><span class="f7">（制作考级证书用），背面清楚写明考生姓名、准考证号码（包括器乐和乐理），</span>交至考场工作人员处。`},
          {attent:`7、补考的考级证书于3月下旬以快递到付形式发放，请保证通讯畅通。如果4月份依旧没有收到证书，可致电025-83572077咨询。`},
        ],
        // desc_list:[
        //   {text:`<span class='ipmStyle'>各位考生、家长和老师，请在报名前认真阅读2019年江苏省音乐家协会暑期考级报名须知。这将为您提供更多方便和帮助。</span>`},
        //   {text:`一、本次网络报名只针对8月1日至8月5日在江苏省妇女儿童活动中心（莫愁湖西路7号）考级的考生。`},
        //   {text:`二、考级报名时间为5月20日至6月30日，逾期不予报名。`},
        //   {text:`三、考试时间（选座位）为7月10日-7月15日，考级时间一旦选定不予更改，不在规定时间内参加考级的视作缺考，不予补考。`}, 
        //   {text:`四、注意事项：`} 
        // ],
        // attent_list:[
        //   {attent:`1、妥善保管账号及密码，以前注册过的帐号可以继续使用。`},
        //   {attent:`2、请考生报名前征求指导教师意见，根据本人实际演奏（唱）程度选择适当的级别后再填报，<span class='ipmStyle'>报名成功后将无法更改考级信息且不予退款。</span>`},
        //   {attent:`3、提交报名信息前，请仔细核对考生报考信息（<span class='ipmStyle'>身份证号、乐种、级别、辅导课等</span>），付款成功后，<span class='ipmStyle'>将无法更改信息以及退款。</span>`},
        //   {attent:`4、提交报名表信息后请在<span class='ipmStyle'>30分钟</span>内付款，超过时间需要重新填写报名信息。`},
        //   {attent:`5、8-10级有免试资格的考生，请准确勾选免试的科目，并在备注框中填写已通过的准考证号码及具体考试地点。（成绩三年内有效（含考级当年），逾期无效）`},
        //   {attent:`6、根据个人需要，8级、9-10级考生可选择“乐理辅导课”，钢琴考生可选择“钢琴辅导”，声乐考生可选择“声乐伴奏”。<a>（点击查看课程安排)</a>`},
        //   {attent:`7、7月10日零点起可登陆报名网站自主选择具体考试时间段，7月初会在官网和微信公布详细操作流程；7月18日起可查询具体考试时间及考场；考级时间一旦生成无法更改，不在规定时间内参加考级的视作缺考，不予补考。`},
        //   {attent:`8、器乐/声乐<span class='ipmStyle'>考级当天</span>，请考生携带<span class='ipmStyle'>2寸证件照1张</span>（制作考级证书用），背面清楚写明<span>考生姓名、准考证号码</span>，交至考场工作人员处。`},
        //   {attent:`9、考级证书于9月中下旬以快递到付形式发放，请保证通讯畅通。如果11月份依旧没有收到证书，可致电025-83572077咨询。`},
        // ],
      }
    },
    created() {
      console.log(localStorage.getItem("token"));
    },
    methods:{
      sendFill(){
        this.$emit("listenFill","false")
      },
      courseClick(index){
        if(index==5){
            let urls = window.Global.domain+"/downLoad/downloadExcel?fileName=info.xls"
            window.open(urls)
        }
      }
      // signSend(){
      //   console.log(111)
      //   this.$emit('fillfrom',true)
      //    sessionStorage.setItem('signShow',true)
      // }
    }
}
</script>

<style lang="less">
@import '../../static/less/onlineRegis.less';
</style>



// WEBPACK FOOTER //
// src/components/OnlineRegis.vue